import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Select, { components } from "react-select";
import { FormatCurrencys } from "../../../utils/commonUtil";
import "../../i18n/lang";

// 🔹 Custom Menu (Filter term + amountDay + Input Search)
const CustomMenu = (props) => {
    const { t } = useTranslation();
    const {
        originalOptions = [],
        label,
        // lists for tabs
        termTypes = [],
        dayTypes = [],
        // default
        typeDefault,
        amountDayDefault,
        // current selected
        filteredType,
        filteredAmountDay,
        // setters
        setFilteredType,
        setFilteredAmountDay,
        setFilteredOptions,
        // api search (optional)
        searchApi,
        setPackageSelect,
    } = props.selectProps;

    const [type, setType] = useState(filteredType ?? typeDefault ?? "ALL");
    const [termType, setTermType] = useState([]);
    const [option, setOption] = useState([]);

    const [optionType, setOptionType] = useState('');
    const [searchText, setSearchText] = useState("");

    const normalize = (v) => (v === null || v === undefined ? "" : String(v));

    const applyFilter = async (keyword, t, d) => {
        const kw = normalize(keyword).toLowerCase();

        const filtered = originalOptions.filter((opt) => {
            const termOk = t === "ALL" ? true : normalize(opt?.term) === normalize(t);
            const dayOk =
                d === "ALL" ? true : Number(opt?.amountDay) === Number(d);

            const name = normalize(opt?.[label]).toLowerCase();
            const textOk = name.includes(kw);

            return termOk && dayOk && textOk;
        });

        if (filtered.length > 0) {
            setFilteredOptions(filtered);
            return;
        }

        // if not found in local -> call api
        if (kw.trim() !== "" && searchApi) {
            const newData = await searchApi(keyword, t === "ALL" ? null : t, d === "ALL" ? null : d);
            setFilteredOptions(Array.isArray(newData) ? newData : []);
            return;
        }

        setFilteredOptions(filtered);
    };

    useEffect(() => {
        // applyFilter(searchText, type);
        setPackageSelect([])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleTermClick = (item) => {
        setType(item.key);
        setFilteredType(item);
        setTermType(item.children)
    };

    const handleDayClick = (item) => {
        setOptionType(item.key);
        setPackageSelect(item.packages);
    };

    return (
        <components.Menu {...props}>
            {/* ✅ Row 1: term tabs */}
            <div
                style={{
                    display: "flex",
                    gap: 8,
                    padding: "8px",
                    borderBottom: "1px solid #eee",
                    flexWrap: "wrap",
                }}
            >
                {[...termTypes].map((item, i) => (
                    <div
                        key={`term-${item.key}-${i}`}
                        onClick={() => handleTermClick(item)}
                        className={`btn btn-sm ${type === normalize(item.key)
                            ? "btn-success"
                            : "btn-outline-success"
                            }`}
                    >
                        {t(item?.key.toLowerCase())}
                    </div>
                ))}
            </div>

            {/* ✅ Row 2: termType tabs */}
            <div
                style={{
                    display: "flex",
                    gap: 8,
                    padding: "8px",
                    borderBottom: "1px solid #eee",
                    flexWrap: "wrap",
                }}
            >
                {[...termType].map((item, i) => (
                    <div
                        key={`day-${item.key}-${i}`}
                        onClick={() => handleDayClick(item)}
                        className={`btn btn-sm ${String(optionType) === String(item.key)
                            ? "btn-primary"
                            : "btn-outline-primary"
                            }`}
                    >
                        {`${!isNaN(item.key) ? item.key + " " + t("day") : t(item.key)}`}
                    </div>
                ))}
            </div>


            {/* ✅ Search input */}
            <div style={{ padding: 8, borderBottom: "1px solid #eee" }}>
                <input
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    className="form-control"
                    placeholder={t("search.keyword")}
                />
            </div>

            {props.children}
        </components.Menu>
    );
};

// 🔹 MenuList สำหรับ Infinite Scroll
const CustomMenuList = (props) => {
    const { loadMoreOptions } = props.selectProps;

    const handleScroll = (e) => {
        const target = e.target;
        if (target.scrollHeight - target.scrollTop <= target.clientHeight + 1) {
            if (loadMoreOptions) loadMoreOptions();
        }
    };

    return (
        <components.MenuList {...props} onScroll={handleScroll}>
            {props.children}
        </components.MenuList>
    );
};
const getPackageTreeArray = (packages, t) => {
    const longMap = {};
    const shortMap = {};

    packages.forEach((item) => {
        const term = String(item.term || "").toLowerCase();

        if (term === "short") {
            const dayKey = String(item.amountDay || "");

            if (!shortMap[dayKey]) {
                shortMap[dayKey] = [];
            }

            shortMap[dayKey].push(item);
            return;
        }

        if (term === "compulsory" || term === "voluntary") {
            if (!longMap[term]) {
                longMap[term] = [];
            }

            longMap[term].push(item);
        }
    });

    const result = [];

    if (Object.keys(longMap).length > 0) {
        result.push({
            key: "long",
            label: t("uiLabels.longTerm"),
            children: Object.keys(longMap).map((termKey) => ({
                key: termKey,
                label: termKey,
                packages: longMap[termKey],
            })),
        });
    }

    if (Object.keys(shortMap).length > 0) {
        result.push({
            key: "short",
            label: t("uiLabels.shortTerm"),
            children: Object.keys(shortMap)
                .sort((a, b) => Number(a) - Number(b))
                .map((dayKey) => ({
                    key: dayKey,
                    label: `${dayKey} day`,
                    packages: shortMap[dayKey],
                })),
        });
    }
    return result;
};
const FilterableDropdown = ({
    options = [],
    onChange,
    valueKey = "id",
    label = "nameLa", // ✅ default ให้ตรงกับ data ที่ส่งมา
    value,
    typeDefault = "ALL",
    amountDayDefault = "ALL",
    onChangeType,
    onChangeAmountDay,
    filteredTypeInput,
    filteredAmountDayInput,
    isDisabled = false,
    loadMoreOptions,
    searchApi,
}) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState(value);
    const [filteredOptions, setFilteredOptions] = useState(options);

    const [filteredType, setFilteredType] = useState(filteredTypeInput ?? typeDefault);
    const [packageSelect, setPackageSelect] = useState([]);

    useEffect(() => setInputValue(value), [value]);
    useEffect(() => setFilteredOptions(options),[options]);

    const bassData = getPackageTreeArray(options, t)
    // ✅ สร้าง list term อัตโนมัติ
    const termTypes = useMemo(() => {
        const set = new Set(options.map((o) => o?.term).filter(Boolean));
        return Array.from(set);
    }, [options]);


    // ✅ สร้าง list amountDay อัตโนมัติ (sort numeric)
    const dayTypes = useMemo(() => {
        const set = new Set(options.map((o) => o?.amountDay).filter((v) => v !== null && v !== undefined));
        return Array.from(set).sort((a, b) => Number(a) - Number(b));
    }, [options]);

    return (
        <div>
            <Select
                isDisabled={isDisabled}
                options={packageSelect}
                originalOptions={packageSelect}
                setFilteredOptions={setFilteredOptions}
                components={{ Menu: CustomMenu, MenuList: CustomMenuList }}
                placeholder={t("search.keyword")}
                isSearchable={false}

                // ✅ ส่ง config ให้ CustomMenu
                label={label}
                termTypes={bassData}
                typeDefault={typeDefault}
                amountDayDefault={amountDayDefault}
                filteredType={filteredType}
                // filteredAmountDay={filteredAmountDay}
                setFilteredType={(v) => setFilteredType(v)}
                setPackageSelect={(v) => setPackageSelect(v)}
                searchApi={searchApi}

                onChange={(val) => {
                    // ✅ คืนค่า term + amountDay ออกไปด้วย ถ้าต้องการ
                    onChangeType?.(filteredType);
                    // onChangeAmountDay?.(filteredAmountDay);

                    setInputValue(val);
                    onChange?.(val);
                }}

                // ✅ label ที่แสดงใน option
                getOptionLabel={(e) => `${e?.[label] || ""} / ${FormatCurrencys(e?.packagePrice || 0)}`}
                getOptionValue={(e) => String(e?.[valueKey] ?? "")}
                value={inputValue}
                loadMoreOptions={loadMoreOptions}

                styles={{
                    control: (base, state) => ({
                        ...base,
                        minHeight: 45,
                        height: 45,
                        background: "#f0f5f7",
                        borderColor: state.isFocused ? "var(--primary-color)" : base.borderColor,
                        boxShadow: state.isFocused ? "0 0 0 0.5px var(--primary-color)" : "none",
                        "&:hover": { borderColor: "var(--primary-color)" },
                    }),
                    valueContainer: (base) => ({
                        ...base,
                        height: 45,
                        paddingRight: "8px",
                        fontSize: "14px",
                    }),
                    menuList: (base) => ({
                        ...base,
                        fontSize: "14px",
                        maxHeight: 240,
                    }),
                }}
            />
        </div>
    );
};

export default FilterableDropdown;